var map = {
	"./Cybersecurity.jpg": 2821,
	"./Digital-Services.jpg": 8499,
	"./G14C Website Image - Landing Page.png": 5424,
	"./G14C-Website-Image-Cybersecurity.png": 7887,
	"./G14C-Website-Image-cognitive-and-generative-ai.png": 784,
	"./G14C-Website-Image-digital-Services.png": 9953,
	"./G14C-Website-Image-national-security.png": 8635,
	"./Generative-and-Cognitive-AI.png": 4436,
	"./Health-IT-Services.jpg": 3559,
	"./National-Security-Services.jpg": 620,
	"./banner-img.gif": 6665,
	"./banner-img.png": 8138,
	"./scroll-down.png": 3312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1772;